import { useQuery } from '@tanstack/react-query';
import * as api from '~/fetch';
import { TenderActivity } from '~/services/tenders/activity';

export const useOrderActivity = (orderId: string, enabled: boolean) =>
  useQuery({
    queryKey: ['order-activity', orderId],
    queryFn: async () => {
      const response = await api.market.activity(orderId);
      return api.utils.processResponse(response, {
        async 200(response) {
          const data = await response.json();
          return (data.participants ?? []).map(
            (p: any) => new TenderActivity(p)
          );
        },
        async default() {
          return [];
        },
      });
    },
    enabled,
    staleTime: 0,
    gcTime: 30_000,
  });
